var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopicNotAccept(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.565 10.4348L30.565 1.43478C30.282 1.154 29.8987 0.99753 29.5 0.99978H5.5C3.01469 0.99978 1 3.01447 1 5.49978V44.4998C1 46.9851 3.01469 48.9998 5.5 48.9998H35.5C37.9853 48.9998 40 46.9851 40 44.4998V11.4998C40.0023 11.1011 39.8458 10.7179 39.565 10.4348ZM37 44.4998C37 45.3282 36.3285 45.9998 35.5 45.9998H5.5C4.67153 45.9998 4 45.3282 4 44.4998V5.49978C4 4.67131 4.67153 3.99978 5.5 3.99978H28V9.99977C28 11.6566 29.3431 12.9998 31 12.9998H37V44.4998Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 36.9998H31V39.9998H34V36.9998Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 21.9998H7V24.9998H34V21.9998Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 29.4998H7V32.4998H34V29.4998Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36.9998H7V39.9998H28V36.9998Z",
    fill: "#5D5FEF",
    stroke: "#5D5FEF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicNotAccept);
export default __webpack_public_path__ + "static/media/topicNotAccept.36d737d7.svg";
export { ForwardRef as ReactComponent };